import { Component, Input } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular';
import { BasePage } from 'src/app/pages/base.page';
import { Router } from '@angular/router';
import { FlexJobsService } from '../../services/flex-jobs.service';

@Component({
  selector: 'app-confirm-booking',
  templateUrl: './confirm-booking.component.html',
  styleUrls: ['./confirm-booking.component.scss'],
})
export class ConfirmBookingComponent extends BasePage {
  @Input() name: string;

  @Input() jobId: number;

  @Input() user_id: number;

  constructor(
    public modalCtrl: ModalController,
    protected flexJobsService: FlexJobsService,
    protected loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public router: Router,
  ) {
    super('ConfirmBookingComponent');
  }

  /**
   * Confirm booking by accepting the offer
   *
   */
  confirmBooking() {
    this.modalCtrl.dismiss().then(async () => {
      this.showLoading();
      try {
        const res = await this.flexJobsService.flexJobClientAction({
          id: this.jobId,
          workerId: this.user_id,
          action: 'accept',
        });
        if (res) {
          this.router.navigate(['flex/jobs/booked/consumer/', this.jobId], {
            queryParams: {
              redirectUrl: '/tabs/jobs',
            },
          });
        }
      } catch (error) {
        this.showAlert('Error', 'Unable to perform action. Please try again later');
      } finally {
        this.hideLoading();
      }
    });
  }
}
